import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from './store/services/cloudlab/cloudlab';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './Routes/Route';
import { useDispatch } from 'react-redux';
import { setUserDetails } from './store/slices/authSlice';
import './App.css';

function App() {
  const dispatch = useDispatch();
  const jwt = useSelector((state) => state.user.jwt);

 
  const { data: userDetailsData } = useGetUserDetailsQuery(
    { token: jwt },
    { skip: !jwt }
  );

  useEffect(() => {
    if (userDetailsData?.data) {
      dispatch(setUserDetails(userDetailsData.data));
    }
  }, [userDetailsData, dispatch]);

  return (
    <>
      
      <div className="app-wrapper">
        <Router>
          <AppRoutes jwt={jwt} />
        </Router>
      </div>
    </>
  );
}

export default App;
